export const SERVICES = [
  {
    slug: "rubber-covering",
    index: "01",
    name: "Rubber Covering",
    image: "/images/technical_services.jpg",
    short: "New and re-covered rubber rolls, compounded around your process.",
    description:
      "Covering new and used rolls is the core of the Vikas Rolls business, serving domestic and international clients for decades. Every cover is engineered around operating speed, load, pressure, temperature, friction and process medium — plus the characteristics of the end product and the required cover hardness.",
    benefit: "Covers matched to the application deliver consistent nip behaviour, longer wear life and dependable product quality.",
  },
  {
    slug: "pu-covering",
    index: "02",
    name: "Polyurethane Covering",
    image: "/images/pu_covering.jpg",
    short: "Ribbon Build System polyurethane covers for the hardest duties.",
    description:
      "Vikas Rolls applies polyurethane using the Ribbon Build System — the latest PU covering technology. The resulting covers deliver exceptional abrasion and tear resistance, extreme compressive strength and outstanding compatibility with solvents and acids compared with rubber and conventional PU.",
    benefit: "Reduced downtime for roll changing and significantly longer service life in abrasive, high-load positions.",
  },
  {
    slug: "core-manufacturing",
    index: "03",
    name: "Core Manufacturing",
    image: "/images/core_manufacturing.jpg",
    short: "Precision cores and complete rolls for OEMs and end users.",
    description:
      "A trusted manufacturer of custom roll cores for more than three decades, Vikas Rolls controls every stage — material selection, machining, welding, balancing and finishing — from first cut to final delivery.",
    benefit: "Single-source accountability: one supplier controls geometry, welding quality and balance from raw material to finished roll.",
  },
  {
    slug: "regrinding",
    index: "04",
    name: "Regrinding",
    image: "/images/regrinding.jpg",
    short: "Fast restoration of cover geometry and surface finish.",
    description:
      "Regrinding a roll cover returns it to line-ready condition far faster than a complete re-cover. Used rolls receive the same attention as new manufacture — the goal is always to maximise cover life and value.",
    benefit: "Faster turnaround than re-covering, restored geometry and an economical extension of cover life.",
  },
  {
    slug: "balancing",
    index: "05",
    name: "Dynamic Balancing",
    image: "/images/balancing.jpg",
    short: "Smooth high-speed running and extended roll life.",
    description:
      "Balancing extends roller life and allows higher line speeds. A properly balanced roll delivers longer covering life, reduced bearing wear, decreased drag, improved control and the ability to run webs at lower PLI.",
    benefit: "Smoother high-speed operation, less vibration, less bearing wear — and more control over the web.",
  },
  {
    slug: "repairing",
    index: "06",
    name: "Roll Repair & Journal Restoration",
    image: "/images/repairing.jpg",
    short: "Worn rolls restored to original specification.",
    description:
      "Most worn rolls can be repaired to original specification — faster and more economically than manufacturing new. Using a wide choice of welding alloys, surfaces are built back to size and broken journals are replaced. Every roll receives a complete evaluation before any rework begins.",
    benefit: "Economical refurbishment with restored geometry — nearly every part of an existing roll can be repaired or replaced.",
  },
  {
    slug: "induction-hardening",
    index: "07",
    name: "Induction Hardening",
    image: "/images/induction.jpg",
    short: "Uniform surface hardness with a cool core and minimal stress.",
    description:
      "The roll barrel is lowered through a series of electrical coils, heating the surface rapidly before it enters the quench box. Fast heat penetration and immediate quenching create a defined layer of uniform hardness while the necks and core remain cool — minimising internal stress and producing highly favourable metallurgical properties.",
    benefit: "A hard, wear-resistant case over a tough core — without the distortion risks of through-heating.",
  },
  {
    slug: "hard-chrome-plating",
    index: "08",
    name: "Hard Chrome Plating",
    image: "/images/hard_chrome_plating.jpg",
    short: "A super-hard, anti-friction, rust-resistant working surface.",
    description:
      "Abrasion, friction, corrosion, heat and vibration are the most frequent causes of steel roll wear. Chromium plating resists all of them, interposing a super-hard, anti-friction, rust-resistant layer between exposed surfaces, mating surfaces and their surrounding parts.",
    benefit: "Dramatically improved wear and corrosion resistance on new rolls, and a proven route to refurbishing worn surfaces.",
  },
];

export const PROCESS_STEPS = [
  { step: "01", title: "Application Review", text: "We start with your process — speeds, loads, temperatures, media and the product your roll will touch." },
  { step: "02", title: "Roll Inspection", text: "Every incoming roll receives a complete evaluation before any work is scoped or started." },
  { step: "03", title: "Material & Process Selection", text: "Elastomer, compound, core material and treatment are selected against the application requirements." },
  { step: "04", title: "Manufacture / Refurbishment", text: "Machining, welding, covering or repair — carried out under one roof with full process control." },
  { step: "05", title: "Precision Finishing", text: "Grinding and finishing bring the roll to its specified geometry and surface condition." },
  { step: "06", title: "Inspection & Dispatch", text: "Final inspection confirms the roll against specification before it is prepared for dispatch." },
];

export const getService = (slug) => SERVICES.find((s) => s.slug === slug);
